import { CtaBanner } from '@/components/common/CtaBanner'

export function CustomSystemCtaSection() {
  return (
    <CtaBanner
      title="Need a Proprietary Platform Tailored for Your Business?"
      description="All our production foundations can be customized to your exact operational workflows, regulatory demands, and corporate identity — with complete intellectual property ownership."
      ctaText="Request System Architecture Proposal"
      ctaHref="/contact"
      cardSurface="2"
      maxWidth="max-w-3xl"
    />
  )
}
